/**
 * @file Defines the {@link getZIndex} function
 * @author Joe Thompson <joe.thompson@1x2network.com>
 * @version 1.0.30
 */

/**
 * Retrieve highest z-index value for a given CSS selector
 * @returns {number | undefined} highest z-index value for a given CSS selector
 */
export function getZIndex(selector_) {

    return Array.from(document.querySelectorAll(selector_))
           .map(a => parseFloat(window.getComputedStyle(a).zIndex))
           .filter(a => !isNaN(a))
           .sort()
           .pop()

}